module.exports = __webpack_public_path__ + "static/media/phone-icon.8ac7fb8e.svg";